import { AndroidLogo } from '@jouzen/ecom-components/icons/AndroidLogo';
import { AppleLogo } from '@jouzen/ecom-components/icons/AppleLogo';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { PropsWithChildren } from 'react';

import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

import type { PopHighlightedFeaturesSectionData } from '../PopHighlightedFeatures/types';

const LongTermHealthFooterIcon = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex size-11 items-center justify-center rounded-full bg-sandstone-500 text-white">
      {children}
    </div>
  );
};

const LongTermHealthFooter = () => {
  const t = useTranslations();

  return (
    <div className="mt-10 flex items-center">
      <div className="mr-5 flex gap-x-3">
        <LongTermHealthFooterIcon>
          <AppleLogo height={19} width={19} />
        </LongTermHealthFooterIcon>
        <LongTermHealthFooterIcon>
          <AndroidLogo height={23} width={23} />
        </LongTermHealthFooterIcon>
      </div>
      <Typography weight="bold">{t('ios_and_android_compatible')}</Typography>
    </div>
  );
};

const batteryTValues = {
  footnoteLink: () => (
    <sup>
      <a href={`#${LEGAL_FOOTNOTES_ID}`}>*</a>
    </sup>
  ),
};

const getHighlightedFeaturesSections = (
  isAuroraEnabled = false,
): PopHighlightedFeaturesSectionData[] => {
  return [
    {
      copy: {
        messageKey: 'pop_gen4_battery_life_copy_v2',
        tValues: batteryTValues,
      },
      id: 'battery_life',
      title: 'pop_gen4_battery_life_title_v2',
      video: {
        image: {
          srcSet: [
            {
              src: 'blue-sky/pop/gen4/charger-fallback.jpg',
            },
          ],
        },
        video: {
          contentTitle: '',
          location: '',
          src: 'blue-sky/pop/gen4/OMA_SSV_Charger_720_v004.mp4',
          type: 'video/mp4',
        },
      },
    },
    {
      copy: { messageKey: 'pop_gen4_long_term_health_copy' },
      footer: <LongTermHealthFooter />,
      id: 'long_term_health',
      image: {
        localizedAlt: 'pop_gen4_long_term_health_img_alt',
        localizedSrcSet: [
          {
            src: isAuroraEnabled
              ? 'pop_gen4_long_term_health'
              : 'pop_gen4_long_term_health_img_src',
          },
        ],
      },
      title: 'pop_gen4_long_term_health_title',
    },
  ];
};

export default getHighlightedFeaturesSections;
